import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useTranslation } from "react-i18next";
import { SearchBarContainer } from "../shared-components/searchInput/search-input-styles";
import { SearchInput } from "../shared-components/searchInput/SearchInput";
import BonsCoupsContext from "../../../application/Context/BonsCoupsContext";
export var SearchBar = function () {
    var _a = React.useContext(BonsCoupsContext), searchInput = _a.searchInput, handleSearchInput = _a.handleSearchInput, searchBonsCoups = _a.searchBonsCoups, handleKeyDown = _a.handleKeyDown;
    var t = useTranslation(["common"]).t;
    return (_jsxs(SearchBarContainer, { children: [_jsx("label", { htmlFor: "searchinput", style: { display: "none" }, children: t("Search") }), _jsx(SearchInput, { placeholder: t("Search"), id: "searchinput", type: "text", value: searchInput, onChange: handleSearchInput, handleSearch: searchBonsCoups, onKeyDown: handleKeyDown })] }));
};
